import React from 'react'
import { ArrowForwardIos } from "@mui/icons-material";
import { Grid, Slide, Paper, Typography, Button } from "@mui/material";
import { useCallback } from "react";
import { useNavigate } from "react-router";

export default function GettingStarted() {
  const navigate = useNavigate();
  const startCallBack = useCallback(() => {
    localStorage.setItem("acceptedTOC", "true");
    navigate("/form");
  }, []);
  return (
    <Slide direction="right" in appear mountOnEnter unmountOnExit>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
        style={{ height: "90vh" }}
      >
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            flexDirection: "column",
          }}
        >
          <Paper
            sx={{
              maxWidth: "800px",
              overflowY: "scroll",
              padding: 3,
            }}
          >
            <Typography variant="subtitle1">
              SHOPPER TERMS AND CONDITIONS
            </Typography>
            <iframe src="https://untitled-frroz2ar4sij.runkit.sh/" style={{background:'white', border:'none', height: '50vh'}} />
          </Paper>
        </Grid>
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            flexDirection: "column",
          }}
        >
          <Button endIcon={<ArrowForwardIos />} onClick={startCallBack}>
            Start
          </Button>
        </Grid>
      </Grid>
    </Slide>
  );
}
